import forEach from 'util/for-each'
import debounce from 'lodash/debounce'

const truncatedContent = document.querySelectorAll('.js-truncateContent')

/**
 * toggleTruncatedVisibilty toggles visibility on truncated content
 * NOTE: Currently assumes original display value to be 'block'
 *
 * @param {Object} {container, totalChildContent, containerChildren}
 */
function toggleTruncatedVisibilty ({container, totalChildContent, containerChildren}) {

    // Toggle visibile elements at breakpoint
    if (window.matchMedia('(min-width: 960px)').matches) {
        containerChildren.forEach((child) => {
            child.classList.remove('is-notDisplayed')
            child.classList.remove('is-invisible')
        })
    } else {
        const contentVisible = container.getAttribute('data-content-visible')

        if (contentVisible <= totalChildContent) {
            containerChildren.forEach((child, i) => {
                if (i >= contentVisible) {
                    child.classList.add('is-notDisplayed')
                    child.classList.add('is-invisible')
                }
            })
        }
    }
}

// Only run if truncated content exists
if (truncatedContent) {
    forEach(truncatedContent, (container) => {
        // Set some default values and references
        const section = container.getAttribute('data-truncated-section')
        const sectionLoadMore = document.querySelector(`button[data-truncated-section="${section}"]`)
        const containerChildren = [...container.childNodes]
        const totalChildContent = containerChildren.length

        // options for the toggle visibilty function
        const options = {
            container,
            totalChildContent,
            containerChildren
        }

        // Run toggle function on page load and resize
        toggleTruncatedVisibilty(options)
        window.addEventListener('resize', debounce(() => {
            toggleTruncatedVisibilty(options)
        }), 100)

        // Setup load more button event listener
        sectionLoadMore.addEventListener('click', (e) => {
            const contentVisible = container.getAttribute('data-content-visible')
            const hiddenItems = [...container.querySelectorAll('.is-invisible')]

            // // Update opacity loop for dynamic content entrances
            let hiddenIndex = 0
            const showHiddenContent = () => {
                // Check existence of the item first
                if (hiddenItems[hiddenIndex]) {
                    hiddenItems[hiddenIndex].classList.remove('is-notDisplayed')
                    // Nested RAF for sequence animation
                    window.requestAnimationFrame(() => {
                        window.requestAnimationFrame(() => {
                            hiddenItems[hiddenIndex].classList.remove('is-invisible')
                            if (hiddenIndex < 2) {
                                hiddenIndex += 1
                                showHiddenContent()
                            }
                        })
                    })
                }
            }

            showHiddenContent()

            // Set new content visible value
            const newContentVisible = parseInt(contentVisible, 10) + 3
            container.setAttribute('data-content-visible', newContentVisible)

            // Disable button if we are at the end of the content
            if (newContentVisible >= totalChildContent) {
                e.currentTarget.setAttribute('disabled', true)
            }
        })
    })
}
